import React from 'react';

const LinkedinIcon = () => {
  return (
    <svg
      width='52'
      height='30'
      viewBox='0 0 52 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='52' height='30' rx='15' fill='url(#linkedin_gradient)' />
      <path
        d='M19.9991 7C18.8976 7 18.0008 7.89467 18 8.99461C18 10.0945 18.8968 10.9894 19.9991 10.9894C21.1009 10.9894 21.9973 10.0945 21.9973 8.99461C21.9973 7.89479 21.1009 7 19.9991 7Z'
        fill='#043C67'
      />
      <path
        d='M21.5036 11.7938H18.5027C18.3599 11.7938 18.2441 11.9093 18.2441 12.0519V21.6898C18.2441 21.8323 18.3599 21.9478 18.5027 21.9478H21.5035C21.6463 21.9478 21.7621 21.8322 21.7621 21.6898V12.0519C21.7621 11.9092 21.6464 11.7938 21.5036 11.7938Z'
        fill='#043C67'
      />
      <path
        d='M29.1729 11.6798C28.0747 11.6798 27.1097 12.0135 26.5208 12.5576V12.0513C26.5208 11.9088 26.405 11.7933 26.2622 11.7933H23.3836C23.2408 11.7933 23.125 11.9088 23.125 12.0513V21.6892C23.125 21.8317 23.2408 21.9472 23.3836 21.9472H26.3816C26.5244 21.9472 26.6402 21.8317 26.6402 21.6892V16.9209C26.6402 15.5527 26.8924 14.7047 28.151 14.7047C29.391 14.7062 29.4838 15.6156 29.4838 17.0026V21.6892C29.4838 21.8317 29.5996 21.9472 29.7425 21.9472H32.7418C32.8846 21.9472 33.0004 21.8317 33.0004 21.6892V16.4024C33.0003 14.2036 32.5653 11.6798 29.1729 11.6798Z'
        fill='#043C67'
      />
      <defs>
        <linearGradient
          id='linkedin_gradient'
          x1='5.32716e-06'
          y1='30'
          x2='28.5211'
          y2='-14.9106'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E6E6FF' />
          <stop offset='0.5' stopColor='#E5EFFE' />
          <stop offset='1' stopColor='#CCF8FF' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LinkedinIcon;
